import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  hoverEffect?: boolean;
  glass?: boolean;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  hoverEffect = false,
  glass = false,
  padding = 'md',
  onClick
}: CardProps) {
  const baseStyles = 'rounded-2xl border transition-smooth';
  const glassStyles = glass ? 'glass backdrop-blur-modern' : 'bg-slate-900 border-slate-800';
  const hoverStyles = hoverEffect ? 'hover:shadow-glow hover:-translate-y-1 hover:border-cyan-500/30 cursor-pointer' : '';
  const paddingStyles = {
    none: '',
    sm: 'p-4',
    md: 'p-6',
    lg: 'p-8'
  };
  const clickable = onClick ? 'cursor-pointer' : '';
  return <div className={`${baseStyles} ${glassStyles} ${hoverStyles} ${paddingStyles[padding]} ${clickable} ${className}`} onClick={onClick} data-id="element-647">
      {children}
    </div>;
}